import { isiOS, isMobileApp } from '../utils/mobileAppFunctionality'

class SmarticoError extends Error {
  constructor(message, name = 'SmarticoError') {
    super(message)
    this.name = name
    this.isMobileApp = isMobileApp()
    this.isIOS = isiOS()
    this.message = `${message} | Details: ${
      JSON.stringify(this.getDetails())
    }`
  }

  getDetails() {
    return {
      isMobileApp: this.isMobileApp,
      isIOS: this.isIOS,
    }
  }
}

export class SmarticoScriptLoadError extends SmarticoError {
  constructor(error) {
    const baseMessage = 'Error to load script'
    super(baseMessage, 'SmarticoScriptLoadError')
    this.originalError = error
    this.scriptURL = error?.target?.src
    this.message = `${baseMessage} | Details: ${
      JSON.stringify(this.getDetails())
    }`
  }

  getDetails() {
    return {
      ...super.getDetails(),
      originalError: this.originalError,
      scriptURL: this.scriptURL,
    }
  }
}

export class SmarticoStartupError extends SmarticoError {
  constructor(error) {
    const baseMessage = 'Error on startup'
    super(baseMessage, 'SmarticoStartupError')
    this.originalError = error
    this.message = `${baseMessage} | Details: ${
      JSON.stringify(this.getDetails())
    }`
  }

  getDetails() {
    return {
      ...super.getDetails(),
      originalError: this.originalError,
    }
  }
}

export class SmarticoLoginError extends SmarticoError {
  constructor(error) {
    const baseMessage = 'Login error'
    super(baseMessage, 'SmarticoLoginError')
    this.originalError = error
    this.message = `${baseMessage} | Details: ${
      JSON.stringify(this.getDetails())
    }`
  }

  getDetails() {
    return {
      ...super.getDetails(),
      originalError: this.originalError,
    }
  }
}

export class SmarticoLogoutError extends SmarticoError {
  constructor(error) {
    const baseMessage = 'Logout error'
    super(baseMessage, 'SmarticoLogoutError')
    this.originalError = error
    this.message = `${baseMessage} | Details: ${
      JSON.stringify(this.getDetails())
    }`
  }

  getDetails() {
    return {
      ...super.getDetails(),
      originalError: this.originalError,
    }
  }
}

export class SmarticoUpdatePushNotificationTokenError extends SmarticoError {
  constructor(error) {
    const baseMessage = 'Error updating push notification token'
    super(baseMessage, 'SmarticoUpdatePushNotificationTokenError')
    this.originalError = error
    this.message = `${baseMessage} | Details: ${
      JSON.stringify(this.getDetails())
    }`
  }

  getDetails() {
    return {
      ...super.getDetails(),
      originalError: this.originalError,
    }
  }
}